<template>
  <div v-if="Object.keys(data).length">
    <div v-for="(question, questionKey) in data" :key="questionKey" class="content debrief sub">
      <div class="condition hide">{{ JSON.stringify(question.condition) }}</div>
      <div class="question" :data-required="question.required" :data-question-id="question.question_id">
        <div class="label">
          {{ question.question_label }}
          <div class="required" v-if="question.required">( Réponse obligatoire )</div>
        </div>
        <div v-for="(response, responseKey) in question.reponse" :key="responseKey">
          <div
            class="reponse-button action"
            :class="{ check: isChecked(question.question_id, response.reponse_id) }"
            :data-question-id="question.question_id"
            :data-reponse-id="response.reponse_id"
            @click="handleResponseClick(question.question_id, response.reponse_id)"
          >
            <i class="fa fa-check" :class="{ hide: !isChecked(question.question_id, response.reponse_id) }" aria-hidden="true"></i>
            {{ response.reponse_label }}
          </div>
        </div>
        <div v-if="question.custom_response" class="reponse-input" :data-question-id="question.question_id">
          <input type="text" placeholder="Votre réponse" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArbreRecursive',
  props: {
    debrief: Object,
    question: Object,
    response: Object,
    data: Object,
    intervention: Object,
    index: Number,
    requiredResponses: Array
  },
  methods: {
    isChecked (questionId, responseId) {
      if (!this.intervention.pm || !this.intervention.pm[this.index] || !this.intervention.pm[this.index].reponses) {
        return false
      }

      return this.intervention.pm[this.index].reponses.some((r) => {
        if (parseInt(r.question_id) === questionId && parseInt(r.reponse_id) === responseId) {
          return true
        }
      })
    },
    handleResponseClick (questionId, responseId) {
      const responses = this.intervention.pm[this.index].reponses || []
      const existingResponseIndex = responses.findIndex(r => parseInt(r.question_id) === questionId)

      if (existingResponseIndex !== -1) {
        this.$delete(responses, existingResponseIndex)
      }

      this.$set(responses, responses.length, { question_id: questionId, reponse_id: responseId })

      if (this.response.next_question) {
        const response = Object.values(this.response.next_question).find(r => r.question_id === questionId)

        if (response) {
          const requiredResponseIndex = this.requiredResponses.findIndex(r => r.index === this.question.question_id)
          this.$set(this.requiredResponses, requiredResponseIndex, { index: questionId, answered: true })
        }
      }
      this.$forceUpdate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ArbreRecursive.vue